// App.js
import logo from './logo.svg';
import './App.css';
import { AppProvider } from "./Contex";
import { BrowserRouter } from "react-router-dom";
import AppRouter from "./Router";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './util/prototype'
import {useEffect} from "react";


function App() {
  return (
      <AppProvider>
        <BrowserRouter>
          <AppRouter />
        </BrowserRouter>
      </AppProvider>
  );
}

export default App;
